import React, { useState } from "react";

export default function AiToggle() {
  const [enabled, setEnabled] = useState(false);

  return (
    <div 
      className={`ai-toggle ${enabled ? "enabled" : ""}`}
      onClick={() => setEnabled(!enabled)}
    >
      <span className="sparkle"><img src="/static/images/ai_icon.svg" alt="" /></span>
      <span className="label">AI Mode</span>
      <div className="toggle-knob"></div>
    </div>
  );
}
